import { Alert, Col, Row } from 'antd';
import React, { useContext } from 'react';
import { ErrorBoundary, FallbackProps } from 'react-error-boundary';
import { Outlet } from 'react-router-dom';

import ButtonComponent from 'components/atoms/ButtonComponent';

import useNavigateWorkaround from 'hooks/useNavigateWorkaround';

import routePathEnum from 'enums/routePathEnum';

import { Context, defaultStoreState } from './Store';
import TranslateText from './TranslateText';

/** Slouží pro odchytávání nečekaných chyb v aplikaci (globálně pro celou aplikaci)
    zobrazí hlášku uživateli, a vyzve ho k novému přihlášení s vynulováním dat ze Store  */
export const ErrorBoundaryComponent: React.FC = () => {
    const { language, setStoreState } = useContext(Context);
    const { navigateWorkaround } = useNavigateWorkaround();

    /** Funkce provolaná při výskytu chyby v aplikaci */
    const ErrorFallback = ({ error, resetErrorBoundary }: FallbackProps) => {
        const atIndex = error?.stack?.indexOf('@');
        const componentName = atIndex && error?.stack?.substring(0, atIndex);

        return (
            <Row
                style={{
                    height: '100vh'
                }}
            >
                <Col xs={0} sm={0} md={2} lg={4} xl={4} />
                <Col xs={24} sm={24} md={20} lg={16} xl={16}>
                    <div
                        className="flex-center"
                        style={{
                            height: '100%'
                        }}
                    >
                        <Alert
                            style={{
                                width: '100%'
                            }}
                            message={<TranslateText>ERR_BOUNDARY_HEAD</TranslateText>}
                            description={
                                <>
                                    <TranslateText>ERR_BOUNDARY_TEXT</TranslateText>
                                    <div
                                        style={{
                                            padding: '25px',
                                            color: 'red',
                                            fontWeight: 'bold',
                                            fontStyle: 'italic'
                                        }}
                                    >
                                        {componentName && atIndex && (
                                            <p>
                                                <TranslateText>ERR_BOUNDARY_ZPUSOBENO</TranslateText>{' '}
                                                {`'${componentName}'`}
                                            </p>
                                        )}
                                        <p>
                                            {error.name} - {error.message}
                                        </p>
                                        {/* {error.stack} */}
                                    </div>
                                    <TranslateText>ERR_BOUNDARY_ZNOVU</TranslateText>
                                    <ButtonComponent
                                        style={{
                                            marginTop: '15px'
                                        }}
                                        onClick={resetErrorBoundary}
                                        buttontext="PRIHLASIT_SE"
                                    />
                                </>
                            }
                            showIcon={true}
                            type="error"
                        />
                    </div>
                </Col>
                <Col xs={0} sm={0} md={2} lg={4} xl={4} />
            </Row>
        );
    };

    /** Obnova Store do defaultního stavu */
    const resetStoreState = () => {
        setStoreState &&
            setStoreState({
                ...defaultStoreState,
                language: language
            });
        navigateWorkaround(routePathEnum.LOGIN_ROZCESTNIK);
    };

    return (
        <ErrorBoundary FallbackComponent={ErrorFallback} onReset={resetStoreState}>
            <Outlet />
        </ErrorBoundary>
    );
};
